import { Prop, Component, h, Host } from "@stencil/core";
import classNames from "classnames";
import { IconProps } from "./f-icon-model";

/**
 * @name    f-icon
 * @type    atom
 *
 * @param   {string}  iconName    name of the font icon
 * @param   {string}  titleText   tooltip text of the icon
 * @param   {string}  additionalClasses   additional class which can be passed in
 * @param   {boolean} isUiIcon    whether or not it's an icon from the UI font or not
 * component, which uses the bosch icon font
 */
@Component({
  tag: "f-icon",
  styleUrl: "f-icon.scss",
  shadow: true,
})
export class Icon {
  @Prop() iconName: IconProps["iconName"];
  @Prop() titleText: IconProps["titleText"];
  @Prop() isUiIcon: IconProps["isUiIcon"] = false;
  @Prop() size: IconProps["size"] = "m";

  render() {
    const iconClass: string = classNames("a-icon", {
      [`boschicon-bosch-ic-${this.iconName}`]: this.iconName && !this.isUiIcon,
      [`ui-ic-${this.iconName}`]: this.iconName && this.isUiIcon,
      [`a-icon--${this.size}`]: this.size,
    });
    return (
      <Host>
        <span
          class={`${iconClass}`}
          title={this.titleText}
          aria-hidden="true"
          data-test={`icon-${this.iconName}`}
        />
      </Host>
    );
  }
}
